import React from 'react';
import { ActorMark } from '../ActorMark';
import { LevelBadge } from '../../ui/LevelBadge';
import { ProcessingTag } from '../../ui/ProcessingTag';
import { dayGroup } from '../../../utils/logbook';
import { getAgent } from '../../../utils/agents';
import type { LogbookEvent } from '../../../types/beheer';
import type { LogEntry } from '../../../types/db';
const OUTCOME_TONE: Record<LogEntry['outcome'], string> = {
  uitgevoerd: 'text-ink-soft',
  goedgekeurd: 'text-accent',
  gemeld: 'text-ink-soft',
  afgewezen: 'text-amber',
  geweigerd: 'text-amber',
  gestopt: 'text-alarm'
};
interface LogTimelineProps {
  events: LogbookEvent[];
  selectedId: string | null;
  onSelect: (id: string) => void;
}
export function LogTimeline({
  events,
  selectedId,
  onSelect
}: LogTimelineProps) {
  const groups: {
    label: string;
    items: LogbookEvent[];
  }[] = [];
  events.forEach(ev => {
    const label = dayGroup(ev.entry);
    const last = groups[groups.length - 1];
    if (last && last.label === label) last.items.push(ev);else groups.push({
      label,
      items: [ev]
    });
  });
  const onKey = (e: React.KeyboardEvent, index: number) => {
    if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
    e.preventDefault();
    const next = events[index + (e.key === 'ArrowDown' ? 1 : -1)];
    if (next) {
      onSelect(next.entry.id);
      document.getElementById(`log-row-${next.entry.id}`)?.focus();
    }
  };
  if (events.length === 0) {
    return <div className="rounded-2xl border border-dashed border-white/10 px-6 py-16 text-center" data-id="element-174" data-mp="mkh6wldlfo32">
        <p className="text-[15px] text-ink-soft" data-id="element-175" data-mp="hlxlqn6tqgbr">Geen rijen voor deze filters.</p>
        <p className="mt-1 text-[13px] text-ink-muted" data-id="element-176" data-mp="cmugb1mxm839">Verruim een filter om meer te zien.</p>
      </div>;
  }
  let flatIndex = -1;
  return <div className="space-y-8" data-id="element-177" data-mp="2xfee11r036n9">
      {groups.map(g => <div key={g.label} data-id="element-178" data-mp="2xcs7n5fuix6m">
          <h3 className="mb-2 px-3 text-[13px] font-medium text-ink-muted" data-id="element-179" data-mp="2tdjeo2smr3c4">{g.label}</h3>
          <ul aria-label={`Logboek ${g.label.toLowerCase()}`} className="space-y-0.5" data-id="element-180" data-mp="2uugli377iipx">
            {g.items.map(({
          entry
        }) => {
          flatIndex += 1;
          const index = flatIndex;
          const selected = entry.id === selectedId;
          const name = entry.agent === 'systeem' ? 'Systeem' : getAgent(entry.agent).name;
          return <li key={entry.id} data-id="element-181" data-mp="2pxgglvm3fm0e">
                  <button id={`log-row-${entry.id}`} type="button" aria-current={selected ? 'true' : undefined} onClick={() => onSelect(entry.id)} onKeyDown={e => onKey(e, index)} className={`grid w-full grid-cols-[3.25rem_auto_minmax(0,1fr)] items-start gap-3 rounded-xl px-3 py-3 text-left transition-colors duration-150 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent/60 ${selected ? 'bg-white/[0.07]' : 'hover:bg-white/[0.035]'}`} data-id="element-182" data-mp="2c3fdyqs0teur">
                    <span className="pt-1 text-[13px] tabular-nums text-ink-muted" data-id="element-183" data-mp="1einx8wbgq914">{entry.time.replace('gisteren ', '')}</span>
                    <ActorMark actor={entry.agent} size="sm" data-id="element-184" data-mp="1nj2la3fta28b" />
                    <span className="min-w-0" data-id="element-185" data-mp="1nkng7u61fn6p">
                      <span className={`block text-[15px] leading-snug ${selected ? 'text-ink' : 'text-ink-soft'}`} data-id="element-186" data-mp="1ik9523953x4g">{entry.summary}</span>
                      <span className="mt-2 flex flex-wrap items-center gap-2" data-id="element-187" data-mp="1xfyvqep9syfi">
                        <span className="text-[12px] text-ink-muted" data-id="element-188" data-mp="1siyq24wc1xox">{name}</span>
                        <LevelBadge level={entry.level} data-id="element-189" data-mp="269bvo0lr50b3" />
                        <ProcessingTag where={entry.where} data-id="element-190" data-mp="268siex71r03e" />
                        <span className={`text-[12px] font-medium ${OUTCOME_TONE[entry.outcome]}`} data-id="element-191" data-mp="2291h3zjw91km">{entry.outcome}</span>
                      </span>
                    </span>
                  </button>
                </li>;
        })}
          </ul>
        </div>)}
    </div>;
}